import { render, staticRenderFns } from "./correctTheoryPaper.vue?vue&type=template&id=1ee85216&scoped=true&"
import script from "./correctTheoryPaper.vue?vue&type=script&lang=js&"
export * from "./correctTheoryPaper.vue?vue&type=script&lang=js&"
import style0 from "./correctTheoryPaper.vue?vue&type=style&index=0&id=1ee85216&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee85216",
  null
  
)

export default component.exports